import { type CoreUserAddress } from '@flecto/types'
import { useModal } from '@flecto/ui'

import { ModalAddress } from '../components/ModalAddress/ModalAddress'

type UseModalAddressProps = {
  address?: Partial<CoreUserAddress>
  onSuccess?: (address: CoreUserAddress) => void
}

export function useModalAddress(options?: UseModalAddressProps) {
  return useModal<UseModalAddressProps>({
    modalComponent: (props) => <ModalAddress {...options} {...props} />,
  })
}
